var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAutomated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_120)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 0.5,
    r: 10.5,
    fill: "#FF7329"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 11V5H24V7H14V4C13.9992 3.46981 13.7882 2.96156 13.4133 2.58666C13.0384 2.21176 12.5302 2.00079 12 2H4C3.46981 2.00079 2.96156 2.21176 2.58666 2.58666C2.21176 2.96156 2.00079 3.46981 2 4V12C2.00079 12.5302 2.21176 13.0384 2.58666 13.4133C2.96156 13.7882 3.46981 13.9992 4 14H12C12.5302 13.9992 13.0384 13.7882 13.4133 13.4133C13.7882 13.0384 13.9992 12.5302 14 12V9C14.7954 9.00079 15.558 9.31712 16.1204 9.87956C16.6829 10.442 16.9992 11.2046 17 12V21H11V19H5V25H11V23H17V25C17.0008 25.5302 17.2118 26.0384 17.5867 26.4133C17.9616 26.7882 18.4698 26.9992 19 27H24V29H30V23H24V25H19V18H24V20H30V14H24V16H19V12C18.9963 10.9147 18.6362 9.86066 17.975 9H24V11H30ZM4 12V4H12V12H4ZM9 23H7V21H9V23ZM26 25H28V27H26V25ZM26 16H28V18H26V16ZM26 7H28V9H26V7Z",
    fill: "#011165"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_120"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomated);
export default __webpack_public_path__ + "static/media/automated.c4fe4f85cbcd276017251e36055658b6.svg";
export { ForwardRef as ReactComponent };